import React from 'react';

import { benefits } from '~/src/features/yandex-landing/data';

import * as ST from './styled';

const Benefits: React.FC = () => {

    return (
        <ST.Benefits>
            {benefits.map(({ id, imgUrl, text }) => (
                <ST.BenefitsRow key={id}>
                    <ST.Icon imgUrl={imgUrl}/>
                    <ST.BenefitsText>
                        {text}
                    </ST.BenefitsText>
                </ST.BenefitsRow>
            ))}
        </ST.Benefits>
    );
};

export default Benefits;
